import styled from "styled-components";

export const MapContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  padding: 40px 40px 0;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 8px;
  }

    @media (max-width: 768px) {
      height: 300px;
      padding: 20px 20px;
    }
`;